import * as React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AddFactoryShipGroupState } from "./adminFactoryShipGroupHelper";

interface Props {
    state: AddFactoryShipGroupState,
    onHide: () => void;
    onSuccess: (item: any) => void
}

export const RemoveFactoryShipGroup: React.FC<Props> = ({
    state,
    onHide,
    onSuccess
}) => {
    return (
        <Modal className="show nts-terms-modal"
            backdrop="static"
            keyboard={false} 
            onHide={onHide} 
            show={state.show}
            bsSize={"medium"} aria-labelledby={"contained-modal-title-lg"}>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                    REMOVE FACTORY SHIP GROUP
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to remove {state.item.team_shp_grp_nm}?</p>
            </Modal.Body>
            <Modal.Footer>
                <div className={'container-modal'}>
                    <Button className={'pdp-cart-btn btn btn-default '} bsStyle={null} onClick={onHide}>
                        Cancel
                    </Button>   
                    <Button className={'pdp-cart-btn btn btn-primary'} bsStyle={null} onClick={()=>onSuccess(state.item)}>
                        Remove
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
